import React from 'react';

const ViewerFilesTab = ({ files, openPreview }) => {
	return (
		<div className="p-6 space-y-6">
			<div>
				<h2 className="text-xl font-semibold text-gray-900">File Management</h2>
				<p className="text-sm text-gray-500 mt-1">View uploaded files (Read-only)</p>
			</div>

			{/* Files Table with Scrollable Container */}
			<div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
				<div className="max-h-screen overflow-y-auto" style={{ maxHeight: 'calc(100vh - 400px)' }}>
					<table className="min-w-full divide-y divide-gray-300">
						<thead className="bg-gray-50 sticky top-0 z-10">
							<tr>
								<th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
									File
								</th>
								<th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
									Document Type
								</th>
								<th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
									Uploaded By
								</th>
								<th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
									Date
								</th>
								<th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
									Actions
								</th>
							</tr>
						</thead>
						<tbody className="bg-white divide-y divide-gray-200">
							{files.map((file) => (
								<tr key={file.id} className="hover:bg-gray-50">
									<td className="px-4 py-3 whitespace-nowrap">
										<div className="flex items-center">
											<div className="flex-shrink-0 h-10 w-10">
												<div className="h-10 w-10 rounded-lg bg-blue-100 flex items-center justify-center">
													<svg className="w-6 h-6 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
														<path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
													</svg>
												</div>
											</div>
											<div className="ml-4">
												<button
													onClick={() => openPreview(file)}
													className="text-sm font-medium text-blue-600 hover:text-blue-800 hover:underline cursor-pointer"
												>
													{file.originalName}
												</button>
												<div className="text-sm text-gray-500">{file.fileSize ? `${((file.fileSize / 1024) / 1024).toFixed(2)} MB` : 'Unknown size'}</div>
											</div>
										</div>
									</td>
									<td className="px-4 py-3 whitespace-nowrap">
										{file.fileCategory ? (
											<span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${
												file.fileCategory.includes('PITCH') || file.fileCategory.includes('PRESENTATION') || file.fileCategory.includes('DECK') ? 'bg-purple-100 text-purple-800' :
												file.fileCategory.includes('FINANCIAL') || file.fileCategory.includes('VALUATION') || file.fileCategory.includes('CAP_TABLE') || file.fileCategory.includes('BALANCE') || file.fileCategory.includes('CASH_FLOW') || file.fileCategory.includes('P_L') ? 'bg-green-100 text-green-800' :
												file.fileCategory.includes('LEGAL') || file.fileCategory.includes('AGREEMENT') || file.fileCategory.includes('SHA') || file.fileCategory.includes('TERM') || file.fileCategory.includes('NDA') || file.fileCategory.includes('PATENT') || file.fileCategory.includes('TRADEMARK') || file.fileCategory.includes('IP') ? 'bg-blue-100 text-blue-800' :
												file.fileCategory.includes('BUSINESS') || file.fileCategory.includes('MARKET') || file.fileCategory.includes('COMPETITIVE') || file.fileCategory.includes('PRODUCT') || file.fileCategory.includes('TECHNICAL') ? 'bg-orange-100 text-orange-800' :
												file.fileCategory.includes('COMPLIANCE') || file.fileCategory.includes('LICENSE') || file.fileCategory.includes('REGULATORY') || file.fileCategory.includes('TAX') ? 'bg-yellow-100 text-yellow-800' :
												file.fileCategory.includes('OPERATIONAL') || file.fileCategory.includes('HR') || file.fileCategory.includes('POLICY') || file.fileCategory.includes('PROCESS') ? 'bg-indigo-100 text-indigo-800' :
												file.fileCategory.includes('MARKETING') || file.fileCategory.includes('SALES') || file.fileCategory.includes('BRAND') ? 'bg-pink-100 text-pink-800' :
												'bg-gray-100 text-gray-800'
											}`}>
												{file.fileCategory.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase())}
											</span>
										) : (
											<span className="text-xs text-gray-400">General</span>
										)}
									</td>
									<td className="px-4 py-3 whitespace-nowrap">
										<div className="flex items-center">
											<div className="flex-shrink-0 h-8 w-8">
												<div className="h-8 w-8 rounded-full bg-gradient-to-r from-indigo-500 to-purple-500 flex items-center justify-center">
													<span className="text-white text-xs font-medium">
														{(file.uploadedByName || file.uploadedBy || 'Unknown')?.charAt(0)?.toUpperCase()}
													</span>
												</div>
											</div>
											<div className="ml-3">
												<div className="text-sm font-medium text-gray-900">{file.uploadedByName || file.uploadedBy || 'Unknown User'}</div>
												{file.uploadedByEmail && (
													<div className="text-xs text-gray-500">{file.uploadedByEmail}</div>
												)}
											</div>
										</div>
									</td>
									<td className="px-4 py-3 whitespace-nowrap text-sm text-gray-500">
										{new Date(file.uploadedAt).toLocaleDateString()}
									</td>
									<td className="px-4 py-3 whitespace-nowrap text-sm">
										<div className="flex items-center space-x-2">
											<button
												onClick={() => openPreview(file)}
												className="inline-flex items-center px-3 py-1.5 border border-transparent text-xs font-medium rounded-md text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
											>
												<svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
													<path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
													<path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
												</svg>
												Preview
											</button>
										</div>
									</td>
								</tr>
							))}
						</tbody>
					</table>
				</div>
			</div>
		</div>
	);
};

export default ViewerFilesTab;

